<template>
  <div
    v-for="contactType in currentContactType"
    :key="contactType.type.value"
    class="mb-24"
  >
    <h3 class="heading-3 mb-8">
      {{ contactType.type.label }}
    </h3>

    <div v-if="contactType.contacts.length === 0">
      {{ i18n(translations.noContacts) }}
    </div>

    <div v-else class="flex flex-col">
      <ContactTypesTable
        :contacts="contactType.contacts"
        :email-types="getEmailTypes(contactType.type.value)"
        :table-name="contactType.type.value"
        @contact-deleted="$emit('contact-deleted')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import type { ContactTypeGroup, EmailType } from '~/api/profile/types'

import translations from '../Mailbook.translations'

import ContactTypesTable from './ContactTypesTable.vue'

const i18n = useI18n()

defineEmits<{
  (e: 'contact-deleted'): void
}>()

const props = defineProps<{
  currentContactType: ContactTypeGroup[]
  emailTypes: EmailType[]
}>()

function getEmailTypes(contactTypeValue: string) {
  return (
    props.emailTypes.find(
      (emailType) => emailType.contactType === contactTypeValue,
    )?.emailTypes || []
  )
}
</script>
